import { List, Map } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/shared/utils/utils';

interface SafetyViewTabsProps {
  active: 'map' | 'list';
  mapPath: string;
  listPath: string;
}

export const SafetyViewTabs = ({ active, mapPath, listPath }: SafetyViewTabsProps) => (
  <nav
    aria-label="Safety views"
    className="inline-flex gap-1.5 rounded-[13px] border border-border bg-card p-1.5 shadow-slate"
  >
    <Link
      to={mapPath}
      aria-current={active === 'map' ? 'page' : undefined}
      className={cn(
        'inline-flex items-center gap-2 rounded-[9px] px-[18px] py-2.5 text-[13.5px] font-semibold text-muted-foreground transition-colors duration-150 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        active === 'map' && 'bg-accent text-foreground'
      )}
    >
      <Map className="size-4" strokeWidth={1.9} />
      Map
    </Link>
    <Link
      to={listPath}
      aria-current={active === 'list' ? 'page' : undefined}
      className={cn(
        'inline-flex items-center gap-2 rounded-[9px] px-[18px] py-2.5 text-[13.5px] font-semibold text-muted-foreground transition-colors duration-150 hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        active === 'list' && 'bg-accent text-foreground'
      )}
    >
      <List className="size-4" strokeWidth={1.9} />
      List
    </Link>
  </nav>
);
